import Model from 'src/app/common/model';

export default class SoilTypeModel extends Model {
  name: string;
  abbreviation?: string;
  description?: string;

  constructor() {
    super();
  }
}

